(function () {
  'use strict';
  var fields = ['title', 'body', 'product_type', 'tag', 'variants.title', 'vendor', 'variants.sku', 'variants.barcode'];
  // The theme object is used only to retain an unpublished preview, never for customer search logic.
  var previewScript = document.querySelector('script[data-ik-preview-theme]');
  var previewTheme = new URL(location.href).searchParams.get('preview_theme_id') || (previewScript && previewScript.getAttribute('data-ik-preview-theme'));
  function query(value) {
    var text = String(value || '').trim();
    if (!text || /["():\\]|(?:^|\s)(?:AND|OR|NOT)(?:\s|$)/.test(text)) return text;
    return text.split(/\s+/).map(function (word) {
      var literal = JSON.stringify(word);
      return '(' + fields.map(function (field) { return field + ':' + literal; }).join(' OR ') + ')';
    }).join(' AND ');
  }
  function readable(value) {
    var text = String(value || '');
    if (text.indexOf('(title:"') !== 0 || text.indexOf(' OR variants.barcode:"') < 0) return text;
    return text.split(') AND (').map(function (group) {
      var match = group.match(/title:("(?:\\.|[^"\\])*")/);
      if (!match) return group;
      try { return JSON.parse(match[1]); } catch (error) { return group; }
    }).join(' ');
  }
  function url(form, value, type) {
    var destination = new URL(form.action, location.origin);
    destination.searchParams.set('q', query(value));
    destination.searchParams.set('type', type || 'product');
    var preview = previewTheme;
    if (preview) destination.searchParams.set('preview_theme_id', preview);
    return destination.href;
  }
  window.InkAndKeepsSearch = { query: query, readable: readable, url: url };
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[role="search"]')) return;
    var field = form.querySelector('input[name="q"]');
    if (!field) return;
    var raw = readable(field.value).trim();
    if (!raw) { event.preventDefault(); return; }
    field.value = query(raw);
    var preview = previewTheme;
    if (preview) {
      var hidden = form.querySelector('input[name="preview_theme_id"]');
      if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'preview_theme_id'; form.appendChild(hidden); }
      hidden.value = preview;
    }
  }, true);
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[role="search"] input[name="q"]').forEach(function (field) { field.value = readable(field.value); });
  });
  if (/\/search\/?$/.test(location.pathname)) {
    var current = new URL(location.href);
    var raw = current.searchParams.get('q') || '';
    var exact = query(raw);
    if (raw && exact !== raw) { current.searchParams.set('q', exact); current.searchParams.delete('page'); if (previewTheme) current.searchParams.set('preview_theme_id', previewTheme); location.replace(current.href); }
  }
}());
